export const useImpression = (disableAnalytics: boolean, analyticsDataLayer?: unknown[]) => {
  const trackImpression = (data: unknown) => {
    if (disableAnalytics || !Array.isArray(analyticsDataLayer)) {
      return;
    }
    analyticsDataLayer.push(data);
  };

  return {
    trackImpression,
  };
};
